import React, { useState, useEffect, useRef } from 'react';
import { InboxNotificationModel, InboxNotificationType, removeIncomingInboxNotification, setUnseenNotificationsCount } from '../../store/features/inboxSlice';
import { useAppDispatch } from '../../store/hooks';
import { getUnreadNotificationsCount } from '../../api/requests/notifications';

export interface InboxTooltipProps {
    targetRef: any;
    content: any;
    visible: any;
    notificationData?: InboxNotificationModel
}

const InboxTooltip: React.FC<InboxTooltipProps> = (props) => {
    const tooltipRef = useRef<any>(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [isFading, setIsFading] = useState(false);
    const [timer, setTimer] = useState<any>();
    const [isVisible, setIsVisible] = useState(false);
    const dispatch = useAppDispatch();
  
    useEffect(() => {
      if (props.targetRef.current && tooltipRef.current) {
        const targetRect = props.targetRef.current.getBoundingClientRect();
        const tooltipRect = tooltipRef.current.getBoundingClientRect();
  
        let top = targetRect.bottom + window.scrollY;
        let left = targetRect.left + window.scrollX;
  
        // Adjust if the tooltip goes off the right edge of the screen
        if (left + tooltipRect.width > window.innerWidth) {
          left = window.innerWidth - tooltipRect.width - 30;
        }
  
        // Adjust if the tooltip goes off the left edge of the screen
        if (left < 0) {
          left = 0;
        }
  
        // Adjust if the tooltip goes off the bottom edge of the screen
        if (top + tooltipRect.height > window.innerHeight + window.scrollY) {
          top = targetRect.top - tooltipRect.height + window.scrollY;
        }
  
        setPosition({ top, left });
      }
  
      if (isVisible) {
        setIsFading(true);
      } else {
        const timeout = setTimeout(() => setIsFading(false), 300); // Match transition duration
        return () => clearTimeout(timeout);
      }
    }, [props.targetRef, isVisible]);

    const formatNotificationMessage = (data: InboxNotificationModel) => {
      switch (data.type) {
        case InboxNotificationType.RENTAL_REQUESTED:
          return <div>Kasutaja <span className="text-primary font-bold">{data.senderName}</span> soovib rentida toodet <span className="text-primary font-bold">{data.productName}</span></div>
        case InboxNotificationType.RENTAL_APPROVED:
          return <div>Kasutaja <span className="text-primary font-bold">{data.senderName}</span> kinnitas teie rendi tootele <span className="text-primary font-bold">{data.productName}</span></div>
        case InboxNotificationType.MESSAGE_SENT:
          return <div>Kasutaja <span className="text-primary font-bold">{data.senderName}</span> saatis teie <span className="text-primary font-bold">{data.productName}</span> toote rendi kohta uue sõnumi</div>
        case InboxNotificationType.RENTAL_RETURNED:
          return <div>Kasutaja <span className="text-primary font-bold">{data.senderName}</span> märkis teie rendi tootele <span className="text-primary font-bold">{data.productName}</span> lõpetatuks</div>
        case InboxNotificationType.NEW_MESSAGE:
          return <div>Kasutaja <span className="text-primary font-bold">{data.senderName}</span> saatis teile sõnumi</div>
        default:
          return ""
      }
    }

    useEffect(() => {
        if (props.notificationData) {
          const urlParams = new URLSearchParams(window.location.search);
          const selectedChatId = Number(urlParams.get('selectedChatId'));
          const currentPath = window.location.pathname;

          // Check if the notification should be hidden based on the URL
          if (
              (currentPath.includes('/chats') || currentPath.includes('/rentals-chats')) &&
              props.notificationData.chatChannelId === selectedChatId
          ) {
              dispatch(removeIncomingInboxNotification())
              handleUpdateNotificationsCount();
              return; // Do not show the notification
          }

          setIsVisible(true);
          setTimer(setTimeout(() => {
              setIsVisible(false);
              dispatch(removeIncomingInboxNotification())
          }, 5000))
        }

        return () => {
            setIsVisible(false);
            clearTimeout(timer);
        }
    }, [props.notificationData])

    const handleUpdateNotificationsCount = async () => {
      const countNewUnreadNotifications = await getUnreadNotificationsCount();
      dispatch(setUnseenNotificationsCount(countNewUnreadNotifications));
    }

    return (
      <div className='shadow-main '
        ref={tooltipRef}
        style={{
          position: 'absolute',
          top: `110%`,
            transform: 'translateX(calc(-100% + 36px))',
            visibility: isFading || isVisible ? 'visible' : 'hidden',
          color: 'black',
          background: "white",
          padding: '8px',
          borderRadius: '4px',
          zIndex: 2000,
          whiteSpace: 'wrap',
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          maxWidth: "200px",
          minWidth: "200px",
          textAlign: "left",
          border: "1px solid #4287f5"
        }}
      >
        <div style={{ position: 'relative' }}>
            {props.notificationData ? formatNotificationMessage(props.notificationData) : ""}
        </div>
          <div className=''
               style={{
                   position: 'absolute',
                   top: '-10px',
                   right: '4px',
                   transform: 'translateX(-50%)',
                   width: '10px',
                   height: '10px',
                   borderLeft: '10px solid transparent',
                   borderRight: '10px solid transparent',
                   borderBottom: '10px solid #4287f5',
                   zIndex: 2000
               }}
          ></div>
      </div>
    );
};

export default InboxTooltip;
